import {OrderedMap, Record} from "immutable"

export type Result = {
    id: number
    from: string
    message: string
    time: number
}[]

interface Properties {
    id: number
    from: string
    message: string
    time: Date
}

export class LogItem extends Record({
    id: undefined,
    from: undefined,
    message: undefined,
    time: undefined,
}) implements Properties {
    id: number
    from: string
    message: string
    time: Date

    constructor(values: Properties) {
        super(values)
    }
}

export type Log = OrderedMap<number, LogItem>

export enum SortType {
    Date,
    From,
    Message,
}

export enum SortDirection {
    Asc,
    Desc,
}

type Sort = {
    type: SortType
    direction: SortDirection
}

export const sort = (log: Log, {type, direction}: Sort): Log => {
    switch (type) {
        case SortType.From:
            log = <Log>log.sort(({from: a}, {from: b}) => (a > b)
                ? ((direction === SortDirection.Asc) ?  1 : -1)
                : ((direction === SortDirection.Asc) ? -1 :  1)
            )

            break

        case SortType.Message:
            log = <Log>log.sort(({message: a}, {message: b}) => (a.trim() > b.trim())
                ? ((direction === SortDirection.Asc) ?  1 : -1)
                : ((direction === SortDirection.Asc) ? -1 :  1)
            )

            break
        default:
            log = <Log>log.sort(({id: a}, {id: b}) => (a > b)
                ? ((direction === SortDirection.Asc) ?  1 : -1)
                : ((direction === SortDirection.Asc) ? -1 :  1)
            )

    }

    return log
}

export const parseResult = (result: Result, log: Log = <Log>OrderedMap()): Log => {
    result.map(({id, from, message, time}) => {
        if (log.has(id)) {
            return
        }

        log = log.set(id, new LogItem({
            id,
            from,
            message,
            time: new Date(time * 1000),
        }))
    })

    return log
}
